import type { PermissionResolver } from './permissionContext';

/**
 * The key, of a list any one of which suffices, that a guard should be asked about: the first whose
 * decision is `allowed`, or the first of the list when none is.
 *
 * One pure helper so every place that gates on "any of these keys" — the sidebar entry, the route
 * guard, a control such as *New follow-up* — asks the same question and cannot disagree. Returning
 * the first key when none is held hands the guard a key it will deny, so the denial still comes
 * from the resolver (a contextual denial keeps its reason) rather than from here. A
 * `denied-contextual` key is not held.
 */
export function firstHeldPermission(
    resolve: PermissionResolver,
    keys: readonly [string, ...string[]],
): string {
    return keys.find((key) => resolve(key).kind === 'allowed') ?? keys[0];
}
